import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input, Select } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import { errorInput, searchSelectProps } from 'src/components/helpers';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import Swal from 'sweetalert2';

const FacilitatorLog = (props) => {
  const { inputs, setInputs, getInfo, parsedQueryString, set_loading, loading, handleInputs } =
    props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const getCaptchaToken = useRecaptchaToken('wedding_login');

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (
      parsedQueryString?.identification &&
      parsedQueryString?.phone &&
      inputs.identification &&
      inputs.phone &&
      inputs.role
    )
      enterReservation({ preventDefault: () => {} });
  }, [inputs.identification]);

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    if (captchaRequired) {
      setInputs({ ...inputs, captcha });
    }
    getInfo(captchaRequired ? { captcha } : {});
  };

  const onInputChange = (event) => {
    handleInputs(event);
    const { name } = event.target;
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  return (
    <>
      <h2 style={{ textAlign: 'center' }}>¡Bienvenido!</h2>
      <RegistrationForm onSubmit={(e) => enterReservation(e)}>
        <label style={{ display: 'block', padding: '20px', fontSize: '35px' }}>
          Escribe tus datos
        </label>
        {Object.values(errorInputs).includes(true) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
        <Input
          style={{ width: '45%' }}
          onChange={onInputChange}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-${'identification'} ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          placeholder="Celular"
          id="phone"
          name={'phone'}
          type="number"
          className={`Registration__input Registration__input-${'phone'} ${
            errorInputs['phone'] ? 'error' : ''
          }`}
          value={inputs.phone}
          onChange={onInputChange}
          style={{ width: '45%', margin: '5px' }}
        />
        <div>
          <Select
            placeholder="Seleccionar rol"
            style={{ width: '45%', margin: '20px 0' }}
            {...searchSelectProps({
              value: inputs?.role,
              handler: (e, { value }) => {
                setInputs({ ...inputs, role: value });
              },
              options: [
                { key: 'pastor', text: 'Pastor', value: 'pastor' },
                { key: 'facilitator', text: 'Facilitador', value: 'facilitator' },
              ],
            })}
          />
        </div>
        <Button primary disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </>
  );
};

export default withRouter(FacilitatorLog);
